import { useSelector as useRawSelector } from 'react-redux';
export const useSelector = (fn) => useRawSelector(fn);
//# sourceMappingURL=useSelector.js.map